export enum MetadataUiViewEnum {
  reassign = 'REASSIGN',
  edit = 'EDIT',
  editAudit = 'EDIT_AUDIT',
  audit = 'AUDIT',
}
